// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.OpencastPaellaVersionPlugin {
    font-family: Helvetica, Arial, sans-serif;
    padding: 1px;
    color: #f0f0f0;
    min-width: 300px
}

.OpencastPaellaVersionPlugin h4 {
    margin: 0 0 10px 0;
    border-bottom: 1px lightgrey solid;
}

.OpencastPaellaVersionPlugin .paella-plugins {
    margin-top: 10px;
    margin-left: 10px;

}

.OpencastPaellaVersionPlugin .row {
    display: flex;
    min-width: 100px;
    padding-top: 1px;
    padding-bottom: 1px;
    border-bottom: 1px #d3a84c dotted;
}

.OpencastPaellaVersionPlugin .row .component {
    max-width: 80%;
}

.OpencastPaellaVersionPlugin .row .version {
    margin-left: auto;
    color: lightblue;
}`, "",{"version":3,"sources":["webpack://./src/css/OpencastPaellaVersionPlugin.css"],"names":[],"mappings":";AACA;IACI,yCAAyC;IACzC,YAAY;IACZ,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;;AAErB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB","sourcesContent":["\n.OpencastPaellaVersionPlugin {\n    font-family: Helvetica, Arial, sans-serif;\n    padding: 1px;\n    color: #f0f0f0;\n    min-width: 300px\n}\n\n.OpencastPaellaVersionPlugin h4 {\n    margin: 0 0 10px 0;\n    border-bottom: 1px lightgrey solid;\n}\n\n.OpencastPaellaVersionPlugin .paella-plugins {\n    margin-top: 10px;\n    margin-left: 10px;\n\n}\n\n.OpencastPaellaVersionPlugin .row {\n    display: flex;\n    min-width: 100px;\n    padding-top: 1px;\n    padding-bottom: 1px;\n    border-bottom: 1px #d3a84c dotted;\n}\n\n.OpencastPaellaVersionPlugin .row .component {\n    max-width: 80%;\n}\n\n.OpencastPaellaVersionPlugin .row .version {\n    margin-left: auto;\n    color: lightblue;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
